module.exports = __webpack_public_path__ + "static/media/pdf.4a26d5d8.svg";